module.exports = __webpack_public_path__ + "static/media/notify.a1a1337a.svg";